const validateRules = {
	password: {
		// eslint-disable-next-line
		regExpression: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[#?!@$%^&*-]).{8,}$/,
		errorText:
			'Password should contain a minimum of eight characters, at least one uppercase letter, one lowercase letter, and one special character'
	},
	email: {
		// eslint-disable-next-line
		regExpression: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,5})$/,
		errorText: 'Incorrect email'
	},
	url: {
		// eslint-disable-next-line
		regExpression: /^(?:http(s)?:\/\/)?(?:ftp:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
		errorText: 'Incorrect URL',
		placeholder: 'http://'
	}
};

export default validateRules;
